import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Moon, Activity, Droplet, Brain } from 'lucide-react';
export function SolutionRRH() {
  const axes = [{
    icon: Moon,
    title: 'Sueño',
    desc: 'Tu cargador real'
  }, {
    icon: Activity,
    title: 'Cortisol',
    desc: 'Tu activación y tu estrés'
  }, {
    icon: Droplet,
    title: 'Glucosa',
    desc: 'Picos y bajones'
  }, {
    icon: Brain,
    title: 'Sistema nervioso',
    desc: 'Calma vs alerta'
  }];
  return <section className="py-24 bg-[#1a1f3a] text-[#faf8f5] relative overflow-hidden" data-id="element-181">
      {/* Decorative background circles */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#d4a574] rounded-full mix-blend-overlay filter blur-[128px] opacity-10" data-id="element-182"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#8da399] rounded-full mix-blend-overlay filter blur-[128px] opacity-10" data-id="element-183"></div>

      <div className="container mx-auto px-6" data-id="element-184">
        <div className="max-w-4xl mx-auto" data-id="element-185">
          <FadeIn data-id="element-186">
            <div className="text-center mb-16" data-id="element-187">
              <span className="text-[#d4a574] font-medium tracking-wider text-sm uppercase mb-4 block" data-id="element-188">
                La Solución
              </span>
              <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6" data-id="element-189">
                RRH: Realineamiento del Ritmo Hormonal
              </h2>
              <p className="text-xl text-gray-300 leading-relaxed" data-id="element-190">
                RRH es un método simple de microajustes diarios (5–15 minutos)
                para ordenar 4 ejes que controlan tu energía.
              </p>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-191">
            {axes.map((axis, i) => <FadeIn key={i} delay={i * 100} data-id="element-192">
                <div className="bg-[#ffffff08] border border-[#ffffff10] p-6 rounded-2xl text-center hover:bg-[#ffffff10] transition-colors duration-300" data-id="element-193">
                  <div className="w-12 h-12 bg-[#d4a574] rounded-full flex items-center justify-center mx-auto mb-4 text-[#1a1f3a]" data-id="element-194">
                    <axis.icon className="w-6 h-6" data-id="element-195" />
                  </div>
                  <h3 className="text-lg font-bold mb-2" data-id="element-196">{axis.title}</h3>
                  <p className="text-sm text-gray-400" data-id="element-197">{axis.desc}</p>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={500} data-id="element-198">
            <div className="text-center bg-gradient-to-r from-[#d4a574] to-[#c39260] text-[#1a1f3a] p-8 rounded-2xl shadow-xl transform hover:scale-[1.02] transition-transform duration-300" data-id="element-199">
              <h3 className="text-2xl font-bold mb-2" data-id="element-200">
                Y aquí viene lo importante:
              </h3>
              <p className="text-xl font-medium" data-id="element-201">
                No se trata de hacer más. Se trata de hacerlo a tiempo.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}